export default "__VITE_ASSET__Bz8Hu4AI__"